module.exports = __webpack_public_path__ + "img/sld_scb_15_t1_b1.20b7a80a.svg";